// extracted by extract-css-chunks-webpack-plugin
module.exports = {"navigation-icon-btn":"navigation-icon-btn","contacts-search":"contacts-search","search-input":"search-input","ng-hide":"ng-hide"};